import React from "react";
import Link from "next/link";
import Image from "next/image";

const ReportGrid = ({ postData }) => {
  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  if (!postData) {
    return (
      <div className="flex justify-center items-center text-center mx-auto w-full min-h-[20rem] -mt-8">
        <span className="text-xl text-gray-500">No posts available</span>
      </div>
    );
  }

  return (
    <section id="research-reports" className="mt-5 bg-white min-h-[20rem]">
      {postData.length > 0 ? (
        <ul className="space-y-4">
          {postData.map((post) => {
            const postSlug = generateSlug(post.title);
            return (
              <li
                key={post.id}
                className="flex flex-col-row md:flex-row sm:flex-row justify-center items-center bg-white p-4 border-b"
              >
                <div className="flex-1">
                  <Link
                    href={`/content/reports/post/${post.id}/${postSlug}`}
                    as={`/content/reports/post/${post.id}/${postSlug}`}
                  >
                    <h3 className="text-sm lg:text-lg md:text-lg sm:text-sm line-clamp-2 font-bold hover:text-blue-600">
                      {post.title}
                    </h3>
                  </Link>
                  <div
                    className="line-clamp-3 font-light  overflow-hidden my-2 max-h-[4.5em] hidden sm:block"
                    dangerouslySetInnerHTML={{
                      __html: post.excerpt || post.expcert,
                    }}
                  />
                  <p className="text-sm pt-2 text-gray-500">
                    Published on:{" "}
                    {new Date(post.published_date).toLocaleDateString()}
                  </p>
                </div>
                {post.image_url && (
                  <div className="image-container md:w-1/3 sm:w-1/3 w-1/3 md:pl-5 sm:pl-5 pt-5 md:pt-0 mb-4 sm:pt-0">
                    <Image
                      src={post.image_url}
                      alt={`Thumbnail image representing the research report titled "${post.title}"`}
                      width={180}
                      height={96}
                      className="rounded-lg"
                      blurDataURL="/images/BlurBG.webp"
                      priority={true}
                      style={{
                        objectFit: "contain",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="flex justify-center items-center text-center mx-auto w-full min-h-[20rem] -mt-8">
          <span className="text-xl text-gray-500">
            No research reports available for this company.
          </span>
        </div>
      )}
    </section>
  );
};

export default ReportGrid;
